
import MonacoEditor from '@uiw/react-monacoeditor';

export var zqlValue = `
Selector sibling=new Selector(M_ADM_StudentLink.selector,"sibling");
Selector student=new Selector(M_COMM_Person.selector,"student");
Selector parent=new Selector(M_COMM_Person.selector,"parent");
Query query=new Query(M_ADM_StudentLink.selector,
	Sql.and(Sql.eq(M_ADM_StudentLink.col_Student_Id,1933817),Sql.eq(M_ADM_StudentLink.col_IsMain,1)),
		Join.inner(
			M_ADM_StudentLink.selector,
			Sql.and(Sql.eq(M_ADM_StudentLink.col_LinkPerson_Id,Sql.alias("sibling",M_ADM_StudentLink.col_LinkPerson_Id)),Sql.eq(Sql.alias("sibling",M_ADM_StudentLink.col_IsMain),1)),
			sibling),
		Join.inner(
			sibling,
			Sql.eq(Sql.alias("sibling",M_ADM_StudentLink.col_Student_Id),Sql.alias("student",M_COMM_Person.col_Person_Id)),
			student),
		Join.inner(
			sibling,
			Sql.eq(Sql.alias("sibling",M_ADM_StudentLink.col_Student_Id),M_ADM_Student.col_Student_Id),
			M_ADM_Student.selector),
		Join.inner(
			sibling,
			Sql.eq(Sql.alias("sibling",M_ADM_StudentLink.col_LinkPerson_Id),Sql.alias("parent",M_COMM_Person.col_Person_Id)),
			parent),
		Join.leftOuter(
			parent,
			Sql.eq(Sql.alias("parent",M_COMM_Person.col_User_Id),M_SYS_User.col_User_Id),
			M_SYS_User.selector),
		Join.inner(
			sibling,
			Sql.and(Sql.eq(Sql.alias("sibling",M_ADM_StudentLink.col_Student_Id),M_ADM_Enrollment.col_Student_Id),Sql.and(Sql.eq(M_ADM_Enrollment.col_EnrollmentType,2),Sql.isNull(M_ADM_Enrollment.col_ExitDate))),
			M_ADM_Enrollment.selector),
		Join.inner(
			M_ADM_Enrollment.selector,
			Sql.eq(M_ADM_Enrollment.col_Session_Id,M_ADM_Session.col_Session_Id),
			M_ADM_Session.selector),
		Join.inner(
			M_ADM_Session.selector,
			Sql.eq(M_ADM_Session.col_SessionDef_Id,M_ADM_SessionDef.col_SessionDef_Id),
			M_ADM_SessionDef.selector),
		Join.inner(
			M_ADM_SessionDef.selector,
			Sql.eq(M_ADM_SessionDef.col_EducationPathDef_Id,M_ADM_EducationPathDef.col_EducationPathDef_Id),
			M_ADM_EducationPathDef.selector),
		Join.inner(
			M_ADM_EducationPathDef.selector,
			Sql.eq(M_ADM_EducationPathDef.col_EducationPath_Id,M_ADM_EducationPath.col_EducationPath_Id),
			M_ADM_EducationPath.selector),
		Join.inner(
			M_ADM_Session.selector,
			Sql.eq(M_ADM_Session.col_AcademicYear_Id,M_ADM_AcademicYear.col_AcademicYear_Id),
			M_ADM_AcademicYear.selector),
		Join.inner(
			M_ADM_Enrollment.selector,
			Sql.eq(M_ADM_Enrollment.col_StreamGrade_Id,M_ADM_StreamGrade.col_StreamGrade_Id),
			M_ADM_StreamGrade.selector),
		Join.inner(
			M_ADM_Enrollment.selector,
			Sql.eq(M_ADM_Enrollment.col_School_Id,M_ADM_School.col_School_Id),
			M_ADM_School.selector),
		Join.inner(
			M_ADM_School.selector,
			Sql.eq(M_ADM_School.col_School_Id,M_STRUCT_Site.col_Site_Id),
			M_STRUCT_Site.selector));`;

export function Zql(prop) {
	const options = {
		"acceptSuggestionOnCommitCharacter": true,
		"acceptSuggestionOnEnter": "on",
		"accessibilitySupport": "auto",
		"autoIndent": false,
		"automaticLayout": true,
		"codeLens": true,
		"colorDecorators": true,
		"contextmenu": true,
		"cursorBlinking": "blink",
		"cursorSmoothCaretAnimation": false,
		"cursorStyle": "line",
		"disableLayerHinting": false,
		"disableMonospaceOptimizations": false,
		"dragAndDrop": false,
		"fixedOverflowWidgets": false,
		"folding": true,
		"foldingStrategy": "auto",
		"fontLigatures": false,
		"formatOnPaste": false,
		"formatOnType": false,
		"hideCursorInOverviewRuler": false,
		"highlightActiveIndentGuide": true,
		"links": true,
		"mouseWheelZoom": false,
		"multiCursorMergeOverlapping": true,
		"multiCursorModifier": "alt",
		"overviewRulerBorder": true,
		"overviewRulerLanes": 2,
		"quickSuggestions": true,
		"quickSuggestionsDelay": 100,
		"readOnly": true,
		"renderControlCharacters": false,
		"renderFinalNewline": true,
		"renderIndentGuides": true,
		"renderLineHighlight": "all",
		"renderWhitespace": "none",
		"revealHorizontalRightPadding": 30,
		"roundedSelection": true,
		"rulers": [],
		"scrollBeyondLastColumn": 5,
		"scrollBeyondLastLine": true,
		"selectOnLineNumbers": true,
		"selectionClipboard": true,
		"selectionHighlight": true,
		"showFoldingControls": "mouseover",
		"smoothScrolling": false,
		"suggestOnTriggerCharacters": true,
		"wordBasedSuggestions": true,
		"wordSeparators": "~!@#$%^&*()-=+[{]}|;:'\",.<>/?",
		"wordWrap": "off",
		"wordWrapBreakAfterCharacters": "\t})]?|&,;",
		"wordWrapBreakBeforeCharacters": "{([+",
		"wordWrapBreakObtrusiveCharacters": ".",
		"wordWrapColumn": 80,
		"wordWrapMinified": true,
		"wrappingIndent": "none",
		"theme": 'vs-dark',
	};

	return (
		<MonacoEditor
			height="500px"
			language="java"
			value={prop.value}
			options={options}
			width="100%"
			onChange={(value) => {
				zqlValue = value;
			}}
		/>
	);
}

export function getZqlValue() {
	return zqlValue;
}
